import React from 'react';
import { observer } from 'mobx-react';

import useStores from '@stores/useStores';
import { FeatureGateBadge } from './featureGateBadge';
import { useUpgradeNavigation } from '../../common/useUpgradeNavigation';
import { ServerFeatures } from '@stores/features';
import { experiment, FeatureFlagKeys } from '@lib/experiment';
import { Flex } from '@ui-library/flex';
import { TrialBaseBadge } from '@components/trial/common/trialBaseBadge';

interface TrialFeatureTagProps {
  featureKey?: keyof ServerFeatures;
  compact?: boolean;
  children?: React.ReactElement;
  variant?: 'default' | 'daysRemaining';
}

export const FeatureTrialTag: React.FC<TrialFeatureTagProps> = observer(
  ({ featureKey, compact, variant = 'default', children }) => {
    const { trialStore } = useStores();
    const onUpgrade = useUpgradeNavigation();
    const isPLGTrialEnabled = experiment.isFeatureEnabled(FeatureFlagKeys.enablePlgTrial);
    const trialInfo = featureKey ? trialStore.getFeatureTrialInfo(featureKey) : null;
    if (!isPLGTrialEnabled || !trialInfo) {
      return children || null;
    }

    const isTrialActive = trialInfo.trial.status === 'in_progress';
    const badge =
      variant === 'daysRemaining' ? (
        <TrialBaseBadge
          label={`Trial - ${trialStore.trialDaysRemaining}d left`}
          trialPhase={trialInfo.phase}
          compact={compact}
        />
      ) : (
        <FeatureGateBadge
          compact={compact}
          isTrialActive={isTrialActive}
          daysRemaining={trialInfo.daysRemaining}
          trialPhase={trialInfo.phase}
          trialType={trialInfo.trial.definition.trialType}
          onUpgrade={onUpgrade}
        />
      );

    return (
      <Flex gap="4px">
        {children}
        {badge}
      </Flex>
    );
  },
);
